var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.677501 1.18582C0.599397 1.26393 0.599397 1.39056 0.677501 1.46867L5.62076 6.41192C5.69886 6.49003 5.8255 6.49003 5.9036 6.41192L10.8469 1.46867C10.925 1.39056 10.925 1.26393 10.8469 1.18582L10.0161 0.355066C9.938 0.276961 9.81136 0.276961 9.73326 0.355066L5.9036 4.18472C5.8255 4.26283 5.69886 4.26283 5.62076 4.18472L1.7911 0.355067C1.713 0.276962 1.58636 0.276962 1.50826 0.355067L0.677501 1.18582Z",
    fill: "#3C4579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.ce617257217f68cbcf14bb05e651e92e.svg";
export { ForwardRef as ReactComponent };